import { render } from "./VersionHistory.vue?vue&type=template&id=4171d720&scoped=true"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"

import "./VersionHistory.vue?vue&type=style&index=0&id=4171d720&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4171d720"]])

export default __exports__